import { Swiper } from './swiper-D_0i_b49.js';
import { P as Pagination } from './pagination-Ror5spP5.js';
import { A as A11y } from './a11y-Bc4Hy9nX.js';
import './utils-oQVxRlcV.js';

class USPSSection extends HTMLElement {
  #swiper = this;
  #pagination = this.querySelector('.swiper-pagination');

  connectedCallback() {
    new Swiper(this.#swiper, {
      modules: [A11y, Pagination],
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: this.#pagination,
        type: 'bullets',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  }
}

customElements.define('usps-section', USPSSection);
